import { Directive, ElementRef, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, inject } from '@angular/core';
import { I18nService } from '../i18n.service';
import { Subscription } from 'rxjs';

/**
 * This directive sets the placeholder attribute of an element, but otherwise behave the same as TranslateDirective.
 *
 * @param transPlaceholder The translation key to use.
 *
 * @example
 * <input type="text" transPlaceholder="some.example.key">
 */
@Directive({
  selector: '[transPlaceholder]',
  standalone: true,
})
export class TranslatePlaceholderDirective implements OnInit, OnChanges, OnDestroy {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly i18n = inject(I18nService);

  private phrase: string;
  private subscription: Subscription | undefined;

  @Input()
  public set transPlaceholder(phrase: string) {
    this.phrase = phrase;
  }

  ngOnInit() {
    this.draw();
    this.subscription = this.i18n.updated.subscribe(() => {
      this.draw();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.transPlaceholder) {
      this.draw();
    }
  }

  draw() {
    const text = this.i18n.getPhrase(this.phrase);
    this.el.nativeElement.setAttribute('placeholder', text);
  }
}
